import React from 'react';
import { Radio } from 'antd';
import PillButton from '../PillButton/PillButton';

type ChoiceOption = {
  value: string | number;
  label: React.ReactNode;
  description?: React.ReactNode;
  danger?: boolean;
};

type AddonSwitch = {
  name?: string;
  label?: string;
  checkedText?: string;
  uncheckedText?: string;
  defaultChecked?: boolean;
};

type Props = {
  name?: string;
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
  options: [ChoiceOption, ChoiceOption];
  addonSwitch?: AddonSwitch;
  value?: string | number;
  onChange?: (val: string | number) => void;
  className?: string;
};

export const RadioButtonWithSupport: React.FC<Props> = ({
  name,
  label = 'CV Requirement',
  tooltip,
  options,
  addonSwitch,
  value,
  onChange,
  className,
}) => {
  const [left, right] = options;

  const pill = addonSwitch ? (
    <PillButton label={addonSwitch.label ?? 'Quick apply'} />
  ) : // <Form.Item
  null;

  return (
    <div className={className}>
      <Radio.Group
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="flex gap-6">
        {/* Left option */}
        <label className="flex cursor-pointer select-none">
          <Radio value={left.value} className="mt-1" />
          <div className="ml-2">
            <div className="text-[13px] font-medium text-gray-800">{left.label}</div>
            {left.description && (
              <div className="text-[12px] text-gray-500 -mt-0.5">{left.description}</div>
            )}
          </div>
        </label>

        {/* Right option with red ring when selected */}
        <label className="flex cursor-pointer select-none">
          <Radio
            value={right.value}
            className={`mt-1 ${
              right.danger ? '[&_.ant-radio-inner]:ring-2 [&_.ant-radio-inner]:ring-red-500' : ''
            }`}
          />
          <div className="ml-2">
            <div className="text-[13px] font-medium text-gray-800">{right.label}</div>
            {right.description && (
              <div className="text-[12px] text-gray-500 -mt-0.5">{right.description}</div>
            )}
          </div>
        </label>
        {pill}
      </Radio.Group>
    </div>
  );
};
